import React, { useContext } from 'react';
import classnames from 'classnames';
import StartButton from '../Buttons/StartButton';
import { getAccessIconsFromArray } from '../../helpers/getAccessIcon';
import './Event.scss';
import BrowserLink from '../../../../components/BrowserLink';
import { AppContext } from '../../../../AppContext';

export function Event({ data: { title, img, imgAlt, date, time, link, access = '', locked }, highlight, sectionTitle }) {
  const { user } = useContext(AppContext);

  function handleRegisterClick(e) {
    // actid=1

    window.analytics?.track("button:click", {
      "button_name": "Register",
      "parent_object_title": sectionTitle,
      "title": title,
      "url": link
    });
    
    if(link) {
      return;
    }

    window.showPopupPlan({
      title: 'Start your PokerCoaching membership today to unlock this class!',
      planSet: access.includes('pc')
          ? 'standard-premium'
          : 'premium',
      activePremium: access.includes('pc'),
      redirectionObjectTitle: title,
      userAccess: user.type,

    });
    e.preventDefault();
  }

  return (
    <div className={classnames('Event', { 'Event_highlight': highlight })}>
      <p className="Event__date">{date}</p>
      <div className="Event__img-block">
        {img && (
          <img src={img} alt={imgAlt} />
        )}
      </div>
      <h3 className="Event__title">
        <BrowserLink href={locked ? '/' : link} dangerouslySetInnerHTML={{__html: title}} />
      </h3>
      <time className="Event__time">{time}</time>
      <div className="Event__button-block">
        <StartButton title='Register' link={link || '/'} onClick={handleRegisterClick} />
        <div className="Event__access">
          {getAccessIconsFromArray(access)}
        </div>
      </div>
    </div>
  );
}
